export const workouts = [
  {
    id: 1,
    day: "Day 1",
    name: "Core + Push",
    emoji: "🟦",
    focus: "Core, Chest, Shoulders, Triceps",
    goal: "Strengthen and tone upper body with emphasis on triceps and core",
    warmUp: {
      duration: 5 * 60, // 5 minutes in seconds
      exercises: [
        { name: "Arm circles", duration: 30, details: "15sec forward, 15sec backward" },
        { name: "Wall angels", reps: 10, details: "10sec transition, 50sec exercise" },
        { name: "Glute bridge", reps: 15, details: "lay on back, engage glutes & abs" },
        { name: "Dead bug", reps: 10, details: "same leg & arm backwards; lay on back" },
      ],
    },
    circuit: {
      rounds: 3,
      repsPerExercise: 20,
      exercises: [
        { name: "Push-Ups/Press", details: "ensure good form, go light", reps: 20 },
        { name: "Overhead Tricep Extensions", details: "1 dumbbell, go light", reps: 20 },
        { name: "Plank Shoulder Taps", details: "slow & controlled, 10 per side", reps: 20 },
        { name: "Couch Dips", details: "if hard, do tricep kickbacks", reps: 20 },
        { name: "Standing Shoulder Press", details: "light resistance", reps: 20 },
        { name: "Bent knee drops", details: "left, center, right, etc", reps: 18 },
      ],
    },
    finisher: {
      rounds: 2,
      exercises: [
        { name: "Plank", duration: 45 },
        { name: "Partner Push-Up Hand Slaps", reps: 20, details: "have fun :)" },
        { name: "Partner leg throw", reps: 10, details: "have fun :)" },
      ],
    },
    coolDown: {
      duration: 150, // 2.5 minutes in seconds
      details: "Stretch shoulders, triceps, chest, deep breathing",
    },
    totalDuration: 30 * 60, // 30 minutes in seconds
  },
  {
    id: 2,
    day: "Day 2",
    name: "Core + Legs",
    emoji: "🟩",
    focus: "Core, Quads, Glutes, Balance",
    goal: "Gentle lower-body strength + deep core control",
    warmUp: {
      duration: 5 * 60,
      exercises: [
        { name: "March in place", duration: 60, details: "like a robot" },
        { name: "Glute bridges", reps: 15, details: "engage core with each lift" },
        { name: "Bird Dogs", reps: 10, details: "like running on all fours" },
        { name: "Side-to-side lunges", reps: 10 },
      ],
    },
    circuit: {
      rounds: 3,
      repsPerExercise: 20,
      exercises: [
        { name: "Squat", details: "engage core with each lift", reps: 20 },
        { name: "Wall Sit", duration: 45, details: "30-45 sec hold" },
        { name: "Bodyweight Step-Back Lunges", details: "careful, slow", reps: 20 },
        { name: "Dead Bug", reps: 20, details: "same leg & arm backwards" },
        { name: "Side plank (L)", duration: 60, details: "with progression" },
        { name: "Side plank (R)", duration: 60, details: "with progression" },
      ],
    },
    finisher: {
      rounds: 2,
      exercises: [
        { name: "Plank", duration: 45 },
        { name: "Bicycle crunches", reps: 20, details: "slow, control" },
        { name: "Partner leg throw", reps: 20, details: "have fun :)" },
      ],
    },
    coolDown: {
      duration: 120, // 2 minutes
      details: "Stretch hips, hamstrings, calves, breathing",
    },
    totalDuration: 30 * 60,
  },
  // TO FINISH FROM HERE
  {
    id: 3,
    day: "Day 3",
    name: "Core + Pull",
    emoji: "🟨",
    focus: "Core, Back, Biceps",
    goal: "Improve posture, upper back strength, and core endurance",
    warmUp: {
      duration: 5 * 60,
      exercises: [
        { name: "Arm swings", duration: 60, details: "left, right, etc" },
        { name: "Glute bridge hold", duration: 30 },
        { name: "Cat/cow stretches", reps: 10, details: "" },
      ],
    },
    circuit: {
      rounds: 3,
      repsPerExercise: 20,
      exercises: [
        { name: "Resistance Band Rows", details: "band on" },
        { name: "Reverse Flys", details: "like lateral raises" },
        { name: "Plank with Reach", reps: 10, details: "like walk" },
        { name: "Bicep Curls", details: "band or weights" },
        { name: "Bird Dogs", reps: 10, details: "like running on all fours" },
        { name: "Side Plank with Reach-Through", reps: 10, details: "under back to up" },
      ],
    },
    finisher: {
      rounds: 2,
      exercises: [
        { name: "Russian Twists", reps: 20, details: "optional weight" },
        { name: "V-sits", reps: 20, details: "knees bent" },
        { name: "Partner Push-Up Hand Slaps", duration: 30 },
      ],
    },
    coolDown: {
      duration: 120, // 2 minutes
      details: "Stretch back, biceps, obliques",
    },
    totalDuration: 30 * 60,
  },
  {
    id: 4,
    day: "Day 4",
    name: "Full Body",
    emoji: "🟧",
    focus: "Total-body strength and endurance with core finisher",
    goal: "Tie all movement patterns together, boost muscle tone",
    warmUp: {
      duration: 5 * 60,
      exercises: [
        { name: "Jumping jacks", duration: 60 },
        { name: "Arm & leg swings", duration: 60 },
        { name: "Glute bridges", reps: 10 },
        { name: "Bird dog", reps: 10, details: "Like running on all fours" },
      ],
    },
    circuit: { // Note: Original description says "40 sec work / 20 sec rest"
              // This structure assumes a fixed number of reps, but can be adapted.
              // For now, I'll keep it consistent with other days.
      rounds: 3,
      durationPerExercise: 40, // seconds
      restPerExercise: 20, //seconds
      exercises: [
        { name: "Squat to Overhead Reach", details: "for more core engagement", reps: 28 },
        { name: "Push-Ups/Press", details: "ensure good form, go light", reps: 20 },
        { name: "Step-Back Lunges", details: "careful, slow", reps: 20 },
        { name: "Bent-Over Rows", details: "weights", reps: 20 },
        { name: "bicycle crunches", details: "let it burn", reps: 20 },
        { name: "Standing Shoulder Press", details: "weights", reps: 20 },
        { name: "Superman Pulls", details: "arms out, back in", reps: 20 },
      ],
    },
    finisher: { // Core Finisher
      rounds: 2,
      exercises: [
        { name: "Plank w/ Elbow Tap", details: "plank, tap elbow", reps: 20 },
        { name: "Toe Reaches", details: "lay on back, reach toes/sky", reps: 20 },
        { name: "Dead Bug", reps: 20, details: "same leg & arm backwards" },
      ],
    },
    coolDown: {
      duration: 120, // 2 minutes
      details: "Full-body stretch – focus on arms, abs, hips",
    },
    totalDuration: 30 * 60,
  },
];

// Helper function to structure workout timings more granularly if needed later
export const getWorkoutTimings = (workout) => {
  const timings = [];
  let currentTime = 0;

  // Warm-up
  timings.push({ phase: 'Warm-Up', start: currentTime, duration: workout.warmUp.duration });
  currentTime += workout.warmUp.duration;

  // Circuit
  // Approximation: User mentioned 6 exercises x ~1 min each = 6 min per round x 3 rounds = 18 min for Day 1
  // For Day 4, it's 40s work / 20s rest. 7 exercises * (40+20)s = 7 * 60s = 420s = 7 min per round. 3 rounds = 21 min.
  // This is a simplified calculation for now.
  let circuitDuration = 0;
  if (workout.id === 4) { // Day 4 has timed exercises
    circuitDuration = workout.circuit.rounds * workout.circuit.exercises.length * (workout.circuit.durationPerExercise + workout.circuit.restPerExercise);
  } else { // Other days have rep-based circuits
    // Estimate 1 minute per exercise set on average for rep-based
    const estimatedTimePerRepCircuitExercise = 60; // 1 minute
    circuitDuration = workout.circuit.rounds * workout.circuit.exercises.length * estimatedTimePerRepCircuitExercise;
  }
  timings.push({ phase: 'Circuit', start: currentTime, duration: circuitDuration });
  currentTime += circuitDuration;


  // Finisher
  // Estimate 45s per move + 15s transition = 1 min per move. 3 moves * 2 rounds = 6 min.
  const estimatedTimePerFinisherExercise = 60; // 1 minute (45s work + 15s transition)
  const finisherDuration = workout.finisher.rounds * workout.finisher.exercises.length * estimatedTimePerFinisherExercise;
  timings.push({ phase: 'Finisher', start: currentTime, duration: finisherDuration });
  currentTime += finisherDuration;

  // Cooldown
  timings.push({ phase: 'Cooldown', start: currentTime, duration: workout.coolDown.duration });
  currentTime += workout.coolDown.duration;
  
  // Adjust last phase to ensure total duration is 30 minutes
  const calculatedTotal = timings.reduce((acc, curr) => acc + curr.duration, 0);
  const adjustment = workout.totalDuration - calculatedTotal;
  if (timings.length > 0) {
    timings[timings.length -1].duration += adjustment;
  }
  
  let cumulativeTime = 0;
  return timings.map(t => {
      const timedPhase = {...t, start: cumulativeTime};
      cumulativeTime += t.duration;
      return timedPhase;
  });
}; 